import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchAirports } from '../api/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightDetailsCard from '../components/FlightDetailsCard';
import MultiCityFlights from '../components/MultiCityFlights';
import InternationalReturnCard from '../components/InternationalReturnCard';
import { FaTimes } from "react-icons/fa";
const Flights = () => {
  const [selectedStops, setSelectedStops] = useState([]);
const [form, setForm] = useState({
    origin: "",
    destination: "",
    departure_date: null,
    arrival_date: null, // for roundtrip
    adults: 1,
    children: 0,
    infants: 0,
    cabin_class: "1",
  });
const [departureTimes, setDepartureTimes] = useState([]);
const [arrivalTimes, setArrivalTimes] = useState([]);


  const [selectedOnward, setSelectedOnward] = useState(null);
  const [selectedReturn, setSelectedReturn] = useState(null);
const [chosenFlight, setChosenFlight] = useState(null);
  const [sortBy, setSortBy] = useState("price");
  const [sortOrder, setSortOrder] = useState("asc");
// "asc" or "desc"
  const [showBookingPopup, setShowBookingPopup] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState("");
// 🔹 At top of component





  // 🔹 State for Round Trip Sorting
  const [onwardSortBy, setOnwardSortBy] = useState("price");
const [onwardSortOrder, setOnwardSortOrder] = useState("asc");

  const [returnSortBy, setReturnSortBy] = useState("price");
  const [returnSortOrder, setReturnSortOrder] = useState("asc");









  const [airlineOptions, setAirlineOptions] = useState([]);
const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [showAllAirlines, setShowAllAirlines] = useState(false);
// Build airline options from results

const computeMeta = (flight) => {
    const price = getPrice(flight) || 0;
const duration = getDuration(flight) || 0;
    const departure = getDepartureTime(flight) || 0;
    const arrival = getArrivalTime(flight) || 0;
const key = safeResultIndex(flight) || JSON.stringify({ price, departure, arrival });
    return { price, duration, departure, arrival, key };
  };
const safeResultIndex = (flight) => {
    if (flight.ResultIndex != null) return String(flight.ResultIndex);
    return JSON.stringify(flight.Segments || flight);
  };
function useQuery() {
    return new URLSearchParams(useLocation().search);
  } const query = useQuery();
useEffect(() => {
    if (query.get('journey_type') === '3') { // Multicity
      const origins = query.get('multi_origin')?.split(',') || [];
      const destinations = query.get('multi_destination')?.split(',') || [];
      const departureDates = query.get('multi_departure_date')?.split(',') || [];

      const adults = parseInt(query.get('adults') || '1');
      const children = parseInt(query.get('children') || '0');
      const infants = parseInt(query.get('infants') || '0');
      const cabin_class = query.get('cabin_class') || '2';

      const segments = origins.map((from, index) => ({
        from,
        to: destinations[index] || '',
        departureDate: departureDates[index] ? new Date(departureDates[index]) : null,
        adults,
        children,
        infants,
        cabin_class,
        showDropdown: false
      }));

      setMultiCitySegments(segments);
      setTripType('multicity'); // make sure your radio button 

    }
  }, []);



const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100000);
const [priceRange, setPriceRange] = useState([10000, 80000]); // default range


  // const [activeSegment, setActiveSegment] = useState(0);
// const [error, setError] = useState(null);

  const navigate = useNavigate();
  // const [showDetails, setShowDetails] = useState(false);
// const [activeTab, setActiveTab] = useState('flight');
  const [filterTab, setFilterTab] = useState('onward');
// 'onward' or 'return'


  const handleAirlineChange = (e, legType) => {
  const { value, checked } = e.target;
if (legType === "onward") {
    setOnwardFilters((prev) => ({
      ...prev,
      airlines: checked
        ? [...prev.airlines, value]
        : prev.airlines.filter((a) => a !== value),
    }));
} else {
    setReturnFilters((prev) => ({
      ...prev,
      airlines: checked
        ? [...prev.airlines, value]
        : prev.airlines.filter((a) => a !== value),
    }));
}
};




 const handleDepartureTimeChange = (e, legType) => {
  const value = e.target.value;
if (legType === "onward") {
    setOnwardFilters((prev) => ({
      ...prev,
      departureTimes: prev.departureTimes.includes(value)
        ? prev.departureTimes.filter((t) => t !== value)
        : [...prev.departureTimes, value],
    }));
} else {
    setReturnFilters((prev) => ({
      ...prev,
      departureTimes: prev.departureTimes.includes(value)
        ? prev.departureTimes.filter((t) => t !== value)
        : [...prev.departureTimes, value],
    }));
}
};

  const handleArrivalTimeChange = (e, legType) => {
  const value = e.target.value;
if (legType === "onward") {
    setOnwardFilters((prev) => ({
      ...prev,
      arrivalTimes: prev.arrivalTimes.includes(value)
        ? prev.arrivalTimes.filter((t) => t !== value)
        : [...prev.arrivalTimes, value],
    }));
} else {
    setReturnFilters((prev) => ({
      ...prev,
      arrivalTimes: prev.arrivalTimes.includes(value)
        ? prev.arrivalTimes.filter((t) => t !== value)
        : [...prev.arrivalTimes, value],
    }));
}
};

  const [departureAirports, setDepartureAirports] = useState([]);
  const [selectedDepartureAirports, setSelectedDepartureAirports] = useState([]);
const handleDepartureAirportChange = (e, legType) => {
  const value = e.target.value;
if (legType === "onward") {
    setOnwardFilters((prev) => ({
      ...prev,
      departureAirports: prev.departureAirports.includes(value)
        ? prev.departureAirports.filter((a) => a !== value)
        : [...prev.departureAirports, value],
    }));
} else {
    setReturnFilters((prev) => ({
      ...prev,
      departureAirports: prev.departureAirports.includes(value)
        ? prev.departureAirports.filter((a) => a !== value)
        : [...prev.departureAirports, value],
    }));
}
};


  const [arrivalAirports, setArrivalAirports] = useState([]);
  const [selectedArrivalAirports, setSelectedArrivalAirports] = useState([]);
const handleArrivalAirportChange = (e, legType) => {
  const value = e.target.value;
if (legType === "onward") {
    setOnwardFilters((prev) => ({
      ...prev,
      arrivalAirports: prev.arrivalAirports.includes(value)
        ? prev.arrivalAirports.filter((a) => a !== value)
        : [...prev.arrivalAirports, value],
    }));
} else {
    setReturnFilters((prev) => ({
      ...prev,
      arrivalAirports: prev.arrivalAirports.includes(value)
        ? prev.arrivalAirports.filter((a) => a !== value)
        : [...prev.arrivalAirports, value],
    }));
}
};


  const [airportOptions, setAirportOptions] = useState([]);
  const dropdownRef = useRef(null);
  const [showTravelDropdown, setShowTravelDropdown] = useState(false);
  const [flightResults, setFlightResults] = useState([]);
const [returnResults, setReturnResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
let urlTripType = params.get('tripType') || 'oneway';
  if (['round+trip', 'round_trip', 'roundtrip'].includes(urlTripType)) urlTripType = 'round trip';

  const [tripType, setTripType] = useState(urlTripType);
const [multiCitySegments, setMultiCitySegments] = useState([{
    from: '', to: '', departureDate: null, returnDate: null, travelers: 1, travelClass: 'Economy', showDropdown: false
  }]);
// Parse params
  const origins = params.get("multi_origin")?.split(",") || [];
  const destinations = params.get("multi_destination")?.split(",") || [];
const segs = origins.map((o, i) => ({
    origin: o,
    destination: destinations[i] || "",
  }));
// For one-way / round-trip
  const [fromCity, setFromCity] = useState('');
  const [toCity, setToCity] = useState('');
const [departureDate, setDepartureDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
const [infants, setInfants] = useState(0);
  const [travelClass, setTravelClass] = useState('economy');
// default




  // Build segments like [{ from: "DEL", to: "BLR" }, ...]
  const [segments, setSegments] = useState([]);
const [activeTab, setActiveTab] = useState(0);


  useEffect(() => {
    const segs = origins.map((o, idx) => ({
      from: o,
      to: destinations[idx] || ""
    }));
    setSegments(segs);
  }, [location.search]);
const travelClassLabel = {

    '2': 'Economy',
    '3': 'Premium Economy',
    '4': 'Business',
    '5': 'Premium Business',
    '6': 'First Class',


    economy: 'Economy',
    premium: 'Premium Economy',
    business: 'Business',
    premiumbusiness: 'Premium Business',
    first: 'First Class'
  };
// filter tab (onward / return for round trip)


  // for one-way trips
  const [filters, setFilters] = useState({
    stops: [],
    airlines: [],
    priceRange: [minPrice, maxPrice],
    departureTimes: [],
    arrivalTimes: [],
    departureAirports: [],
    arrivalAirports: []
  });
// Separate filter states for each leg
const [onwardFilters, setOnwardFilters] = useState({
  stops: [],
  airlines: [],
  priceRange: [minPrice, maxPrice],
  departureTimes: [],
  arrivalTimes: [],
  departureAirports: [],
  arrivalAirports: []
});
const [returnFilters, setReturnFilters] = useState({
  stops: [],
  airlines: [],
  priceRange: [minPrice, maxPrice],
  departureTimes: [],
  arrivalTimes: [],
  departureAirports: [],
  arrivalAirports: []
});
useEffect(() => {
  if (tripType === 'oneway') {
    setOnwardFilters(prev => ({ ...prev, priceRange }));
  } else if (tripType === 'round trip') {
    if (filterTab === 'onward') {
      setOnwardFilters(prev => ({ ...prev, priceRange }));
    } else {
      setReturnFilters(prev => ({ ...prev, priceRange }));
    }
  }
}, [priceRange, filterTab, tripType]);
const handleFilterChange = (type, value, filterTab) => {
  const updateFn = filterTab === 'onward' ? setOnwardFilters : setReturnFilters;
const current = filterTab === 'onward' ? onwardFilters : returnFilters;
updateFn({
    ...current,
    [type]: current[type].includes(value)
      ? current[type].filter(v => v !== value)
      : [...current[type], value],
  });
};


  const handleFlightSubmit = (e) => {
    e.preventDefault();

    let payload = {};
if (tripType === "multicity") {
      payload.journey_type = 3;
      payload.multi_origin = multiCitySegments.map(s => s.from);
payload.multi_destination = multiCitySegments.map(s => s.to);
      payload.multi_departure_date = multiCitySegments.map(s => formatDateForApi(s.departureDate));
      payload.adults = multiCitySegments[0]?.adults || 1;
// could sum if needed
      payload.children = multiCitySegments[0]?.children || 0;
      payload.infants = multiCitySegments[0]?.infants || 0;
payload.cabin_class = multiCitySegments[0]?.cabin_class || "2";
    } else {
      // Oneway / Roundtrip
      payload.origin = form.origin;
payload.destination = form.destination;
      payload.departure_date = formatDateForApi(form.departure_date);
      payload.journey_type = tripType === "round trip" ? 2 : 1;
if (tripType === "round trip") {
        payload.arrival_date = formatDateForApi(form.arrival_date);
}
      payload.adults = form.adults;
      payload.children = form.children;
      payload.infants = form.infants;
      payload.cabin_class = form.cabin_class;
}

    payload.direct_flight = true;

    // Build query string
    const queryString = new URLSearchParams(payload).toString();
    navigate(`/flights?${queryString}`);
};
  const formatAirportOption = ({ label, value }) => (
    <div><strong>{label}</strong> <small>({value})</small></div>
  );
const handleAddSegment = () => {
    setMultiCitySegments(prev => [...prev, {
      from: '', to: '', departureDate: null, returnDate: null, travelers: 1, travelClass: 'economy', showDropdown: false
    }]);
};

  const handleRemoveSegment = (index) => {
    setMultiCitySegments(prev => prev.filter((_, i) => i !== index));
  };
const toggleDropdown = (index) => {
    const updated = [...multiCitySegments];
    updated[index].showDropdown = !updated[index].showDropdown;
    setMultiCitySegments(updated);
  };
const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="input-design_input" onClick={onClick} ref={ref}>
      {value || 'Select Date'}
    </div>
  ));
const CustomDateInputreturn = React.forwardRef(({ value, onClick }, ref) => (
    <div className="input-design_input" onClick={onClick} ref={ref}>
      {value || 'Select Return'}
    </div>
  ));
// const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
//   setForm(prev => ({
  //     ...prev,
  //     [name]: type === 'checkbox' ? checked : value,
  //   }));
// };

  const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    // Convert params back to payload
    const payload = {};
    searchParams.forEach((value, key) => {
      // If the value is numeric, parse it
      payload[key] = isNaN(value) ? value : Number(value);
    });

    fetchFlights(payload);
  }, [location.search]);
const fetchFlights = async (payload) => {
  setLoading(true);
  try {
    const responses = await axios.post(
      `${BACKEND_BASE_URL}/api/search-flights`,
      payload
    );
// If backend is returning multiple objects instead of one
    let allResults = [];
if (Array.isArray(responses.data)) {
      responses.data.forEach((resp) => {
        if (resp.Response && resp.Response.ResponseStatus === 1) {
          allResults.push(...(resp.Response.Results || []));
        }
      });
} else if (responses.data.Response) {
      allResults = responses.data.Response.Results || [];
}

    setFlightResults(allResults[0] || []);
    setReturnResults(allResults[1] || []);
} catch (err) {
    console.error("Flight search failed:", err);
    setFlightResults([]);
    setReturnResults([]);
  } finally {
    setLoading(false);
}
};


  const segmentOptions = Array.from(
    new Set(
      (flightResults || [])
        .flatMap(flight =>
          flight.Segments?.flat().map(
            seg =>
              `${seg.Origin?.Airport?.CityName} - ${seg.Destination?.Airport?.CityName}`
          )
        )
        .filter(Boolean)
    )
  );
useEffect(() => {
    if (flightResults.length > 0 && !selectedOnward) {
      setSelectedOnward(flightResults[0]); // default to first onward
    }
  }, [flightResults]);
useEffect(() => {
    if (tripType === "round trip" && returnResults.length > 0 && !selectedReturn) {
      setSelectedReturn(returnResults[0]); // default to first return
    }
  }, [returnResults, tripType]);
// const buildPayload = (data) => ({
  //   journey_type: parseInt(data.journey_type),
  //   origin: data.origin,
  //   destination: data.destination,
  //   departure_date: data.departure_date,
  //   arrival_date: data.arrival_date,
  //   cabin_class: parseInt(data.cabin_class),
  //   adults: parseInt(data.adults),
  //   children: parseInt(data.children),
  //   infants: parseInt(data.infants),
  //   direct_flight: data.direct_flight,
  //   one_stop_flight: data.one_stop_flight,
  //   preferred_airlines: '',
  //   sources: '',
  // });
// const cabinClassMap = {

  //   economy: 1,
  //   premium: 2,
  //   business: 3,
  //   premiumbusiness: 4,
  //   first: 5
  // };
// const mapCabinClass = (type) => {
  //   if (!type) return '1';
//   const map = {
  //     economy: '1', premium: '2', business: '3', first: '4'
  //   };
//   return map[type.toLowerCase()] || '1';
  // };

  // const formatDuration = (min) => {
  //   if (!min) return 'N/A';
//   const h = Math.floor(min / 60);
  //   const m = min % 60;
//   return `${h}h ${m}m`;
  // };

const handleStopChange = (stop) => {
  setSelectedStops((prev) => {
    if (prev.includes(stop)) {
      // Remove stop if already selected
      return prev.filter((s) => s !== stop);
    } else {
      // Add stop
      return [...prev, stop];
    }
  });
};


  useEffect(() => {
    fetchAirports().then(setAirportOptions).catch(() => setAirportOptions([]));
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowTravelDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
const formatDateForApi = (date) => {
    if (!date) return '';
    const d = new Date(date);
return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const query = {
      journey_type: params.get('journey_type') || '1', // backend expects numeric
      origin: params.get('origin') || '',
      destination: params.get('destination') || '',
      departure_date: params.get('departure_date') ? new Date(params.get('departure_date')) : null,
      arrival_date: params.get('arrival_date') ? new Date(params.get('arrival_date')) : null,
      cabin_class: parseInt(params.get('cabin_class')) || 1,
      adults: parseInt(params.get('adults')) || 1,
   
   children: parseInt(params.get('children')) || 0,
      infants: parseInt(params.get('infants')) || 0,
      direct_flight: false,
      one_stop_flight: false,
    };

    // ✅ Update tripType state for radio buttons
    if (query.journey_type === '2') {
      setTripType('round trip');
    } else if (query.journey_type === '3') {
      setTripType('multicity');
    } else {
      setTripType('oneway');
}

    // ✅ Set the form data for the UI
    setForm(query);
// ✅ Auto-fetch only if required fields are present
    if (query.origin && query.destination && query.departure_date) {
      fetchFlights({
        ...query,
        departure_date: formatDateForApi(query.departure_date),
        arrival_date: query.arrival_date ? formatDateForApi(query.arrival_date) : ''
      });
}
  }, []);

    useEffect(() => {
    fetchAirports().then(setAirportOptions).catch(() => setAirportOptions([]));
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowTravelDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
useEffect(() => {
    if (flightResults.length > 0) {
      const airlines = new Set();
      const depMap = new Map(); // Map to store unique departure airports
      const arrMap = new Map(); // Map to store unique arrival airports

      let min = Infinity;
      let max = -Infinity;

      flightResults.forEach(f => {
    
    const segments = f.Segments?.flat?.() || [];

        if (segments.length > 0) {
          // --- START FIX ---
          const firstSeg = segments[0];
          const lastSeg = segments[segments.length - 1]; // Correctly get the last segment

          // Populate Departure Map
          if (firstSeg?.Origin?.Airport) {
            const depAirport = firstSeg.Origin.Airport;
            // Use AirportCode as the key to prevent duplicates
            if (depAirport.AirportCode && !depMap.has(depAirport.AirportCode)) {
              depMap.set(depAirport.AirportCode, {
                code: depAirport.AirportCode,
                name: depAirport.AirportName,
                city: depAirport.CityName
              });
            }
          }

          // Populate Arrival Map
          if (lastSeg?.Destination?.Airport) {
            const arrAirport = lastSeg.Destination.Airport;
            // Use AirportCode as the key to prevent duplicates
            if (arrAirport.AirportCode && !arrMap.has(arrAirport.AirportCode)) {
              arrMap.set(arrAirport.AirportCode, {
                code: arrAirport.AirportCode,
                name: arrAirport.AirportName,
                city: arrAirport.CityName
              });
            }
          }
          // --- END FIX ---
        }

        // Collect airlines and fares from each segment
        
segments.forEach(seg => {
          airlines.add(seg.Airline?.AirlineName);

          const fare = Math.round(f.Fare?.PublishedFare || 0);

          if (fare) {
            min = Math.min(min, fare);
            max = Math.max(max, fare);
}
        });
      });

      setAirlineOptions(Array.from(airlines));
      setDepartureAirports(Array.from(depMap.values())); // This will now have data
      setArrivalAirports(Array.from(arrMap.values())); // This will now have data

      setMinPrice(min);
      setMaxPrice(max);
      setPriceRange([min, max]);
}
  }, [flightResults]);
  const allAirlines = flightResults
    .flatMap(flight => flight.Segments?.flat().map(seg => seg.Airline?.AirlineName) || [])
    .filter(Boolean);
// remove undefined/null

  // Deduplicate (case-insensitive)
  const uniqueAirlines = [...new Set(allAirlines.map(a => a.trim().toLowerCase()))]
    .map(a =>
      allAirlines.find(original => original.toLowerCase() === a) // keep original casing
    );
// Pagination (show more / less)
  const displayedAirlines = showAllAirlines ? uniqueAirlines : uniqueAirlines.slice(0, 4);
// Helper: check if any filter is active
  const isFilterActive =
    selectedStops.length > 0 ||
selectedAirlines.length > 0 ||
    departureTimes.length > 0 ||
    arrivalTimes.length > 0 ||
    selectedDepartureAirports.length > 0 ||
    selectedArrivalAirports.length > 0 ||
priceRange[0] !== minPrice || priceRange[1] !== maxPrice;
  



const applyFilters = (flights, filters, segmentType = "all") => {
  if (!flights) return [];
return flights.filter(flight => {
    let segmentsToCheck = flight.Segments?.flat() || [];

    // -----------------------------
    // ✈️ Handle Different Flight Types
    // -----------------------------
    if (flight.Segments?.length > 1 && Array.isArray(flight.Segments[0])) {
      // 🌍 International Round Trip
      if (segmentType === "onward") segmentsToCheck = flight.Segments[0];
      else if (segmentType === "return") segmentsToCheck = flight.Segments[1];
      else segmentsToCheck = [...(flight.Segments[0] || []), ...(flight.Segments[1] || [])];
    } else if (
   
   Array.isArray(flight.Segments) &&
      flight.Segments.length > 1 &&
      !Array.isArray(flight.Segments[0]?.[0])
    ) {
      // 🧳 Multicity → flatten all city legs
      segmentsToCheck = flight.Segments.flat();
    }

    // -----------------------------
    // 🛑 Stops Filter
    // -----------------------------
    let stopsMatch = true;

    if (filters.stops.length > 0) {
      if (flight.Segments?.length > 1 && Array.isArray(flight.Segments[0])) {
       
 // 🌍 International Round Trip
        const onwardStops = (flight.Segments[0]?.length ||
1) - 1;
        const returnStops = (flight.Segments[1]?.length || 1) - 1;

        const onwardLabel = onwardStops === 0 ?
"Non Stop" : `${onwardStops} Stop`;
        const returnLabel = returnStops === 0 ? "Non Stop" : `${returnStops} Stop`;
if (segmentType === "onward") {
          stopsMatch = filters.stops.includes(onwardLabel);
} else if (segmentType === "return") {
          stopsMatch = filters.stops.includes(returnLabel);
} else {
          stopsMatch =
            filters.stops.includes(onwardLabel) ||
filters.stops.includes(returnLabel);
        }
      } else if (Array.isArray(flight.Segments) && flight.Segments.length > 1) {
        // 🧳 Multicity
        const allStops = flight.Segments.map(seg => (seg.length || 1) - 1);
stopsMatch = allStops.some(stopCount => {
          const label = stopCount === 0 ? "Non Stop" : `${stopCount} Stop`;
          return filters.stops.includes(label);
        });
} else {
        // 🛫 Oneway / Domestic
        const stopCount = (segmentsToCheck.length || 1) - 1;
const stopLabel = stopCount === 0 ? "Non Stop" : `${stopCount} Stop`;
        stopsMatch = filters.stops.includes(stopLabel);
}
    }

    // -----------------------------
    // 🏢 Airline Filter
    // -----------------------------
    const airlinesMatch =
      filters.airlines.length === 0 ||
segmentsToCheck.some(seg => filters.airlines.includes(seg.Airline?.AirlineName));

    // -----------------------------
    // 🕐 Departure Time Filter
    // -----------------------------
    const departureMatch =
      filters.departureTimes.length === 0 ||
segmentsToCheck.some(seg => {
        if (!seg.Origin?.DepTime) return false;
        const hour = new Date(seg.Origin.DepTime).getHours();
        return filters.departureTimes.some(slot => {
          if (slot === "Before 6AM") return hour < 6;
          if (slot === "6AM to 12PM") return hour >= 6 && hour < 12;
          if (slot === "12PM to 6PM") return hour >= 12 && hour < 
18;
          if (slot === "After 6PM") return hour >= 18;
          return false;
        });
      });
// -----------------------------
    // 🛬 Arrival Time Filter
    // -----------------------------
    const arrivalMatch =
      filters.arrivalTimes.length === 0 ||
segmentsToCheck.some(seg => {
        if (!seg.Destination?.ArrTime) return false;
        const hour = new Date(seg.Destination.ArrTime).getHours();
        return filters.arrivalTimes.some(slot => {
          if (slot === "Before 6AM") return hour < 6;
          if (slot === "6AM to 12PM") return hour >= 6 && hour < 12;
          if (slot === "12PM to 6PM") return hour >= 12 && hour < 
18;
          if (slot === "After 6PM") return hour >= 18;
          return false;
        });
      });
// -----------------------------
    // 🌍 Departure & Arrival Airports
    // -----------------------------
    const depAirportsMatch =
      filters.departureAirports.length === 0 ||
      segmentsToCheck.some(seg =>
        filters.departureAirports.includes(seg.Origin?.Airport?.AirportCode) // ✅ FIXED: Check against AirportCode
      );
const arrAirportsMatch =
      filters.arrivalAirports.length === 0 ||
      segmentsToCheck.some(seg =>
        filters.arrivalAirports.includes(seg.Destination?.Airport?.AirportCode) // ✅ FIXED: Check against AirportCode
      );
// -----------------------------
    // 💰 Price Filter
    // -----------------------------
    const fare = flight.Fare?.PublishedFare ||
0;
    const [minPrice, maxPrice] = filters.priceRange || [0, Infinity];
    const priceMatch = fare >= minPrice && fare <= maxPrice;
// ✅ Combine all
    return (
      stopsMatch &&
      airlinesMatch &&
      departureMatch &&
      arrivalMatch &&
      depAirportsMatch &&
      arrAirportsMatch &&
      priceMatch
    );
});
};



    //filter //
  // NOTE: Redundant and buggy filter logic (using incorrect state) removed for clarity and correctness.
  // The 'applyFilters' function above is now the single source of truth for filtering.


  //Unique Flights
  const getUniqueFlights = (flights) => {
    const seen = new Set();
return flights.filter(flight => {
      const key = flight.ResultIndex; // ✅ unique at root level

      if (!key) return false; // ignore flights without a ResultIndex

      if (seen.has(key)) return false;
      seen.add(key);

      return true;
    });
};
const handleSort = (field) => {
  if (tripType === "round trip") {
    if (filterTab === "onward") {
      if (onwardSortBy === field) {
        setOnwardSortOrder(onwardSortOrder === "asc" ? "desc" : "asc");
} else {
        setOnwardSortBy(field);
        setOnwardSortOrder("asc");
}
    } else if (filterTab === "return") {
      if (returnSortBy === field) {
        setReturnSortOrder(returnSortOrder === "asc" ? "desc" : "asc");
} else {
        setReturnSortBy(field);
        setReturnSortOrder("asc");
}
    }
  } else {
    // oneway or multicity — global sorting
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
} else {
      setSortBy(field);
      setSortOrder("asc");
    }
  }
};
useEffect(() => {
  if (flightResults.length > 0) {
    const fares = flightResults.map(f => Math.round(f.Fare?.PublishedFare || 0));
    const min = Math.min(...fares);
    const max = Math.max(...fares);

    setMinPrice(min);
    setMaxPrice(max);
    setPriceRange([min, max]);

    setOnwardFilters(prev => ({ ...prev, priceRange: [min, max] }));
    setReturnFilters(prev => ({ ...prev, priceRange: [min, max] }));
  }
}, [flightResults]);
// Helper functions for sorting
const getPrice = (flight) => flight.Fare?.PublishedFare || 0;
const getDuration = (flight) =>
  flight.Segments?.flat()?.reduce((sum, seg) => sum + (seg.Duration || 0), 0) || 0;
const getDepartureTime = (flight, order) => {
  const firstSeg = flight.Segments?.flat()?.[0];
  return firstSeg?.Origin?.DepTime
    ?
new Date(firstSeg.Origin.DepTime).getTime()
    : (order === "asc" ? Infinity : -Infinity);
};
const getArrivalTime = (flight) => {
  const firstSeg = flight.Segments?.flat()?.[0];
  return new Date(firstSeg?.Destination?.ArrTime || 0).getTime();
};
const sortFlights = (flights, field, order) => {
    const sorted = [...(flights || [])];
sorted.sort((a, b) => {
      // Use cached meta if present, otherwise compute and (locally) cache it.
      const metaA = a.__meta || computeMeta(a);
      const metaB = b.__meta || computeMeta(b);
      // Cache onto objects for this sorted copy to avoid recomputing if called repeatedly
      if (!a.__meta) a.__meta = metaA;
      if (!b.__meta) b.__meta = metaB;

      let valA = 0, valB = 0;
      switch 
(field) {
        case "price": valA = metaA.price; valB = metaB.price; break;
        case "duration": valA = metaA.duration; valB = metaB.duration; break;
        case "departure": valA = metaA.departure; valB = metaB.departure; break;
        case "arrival": valA = metaA.arrival; valB = metaB.arrival; break;
        default: valA = 0; valB = 0;
      }

      if (valA === valB) {
     
   // tie-breaker: stable deterministic order using computed key
        const idA = metaA.key || safeResultIndex(a);
        const idB = metaB.key || safeResultIndex(b);
        if (idA < idB) return order === "asc" ?
-1 : 1;
        if (idA > idB) return order === "asc" ? 1 : -1;
        return 0;
}

      return order === "asc" ? valA - valB : valB - valA;
    });
return sorted;
  };

  // compute destinationCity from selected form.destination (airport code)
  const destinationCity = (() => {
    if (!form?.destination) return null;
    const byCode = arrivalAirports.find(a => a.code === form.destination);
    if (byCode) return byCode.city || null;
    const opt = airportOptions.find(o => o.value === form.destination);
    if (opt && typeof opt.label === 'string') return opt.label;
    return null;
  })();
const visibleArrivalAirports = destinationCity
    ? arrivalAirports.filter(a => (a.city && a.city === destinationCity) || a.code === form.destination)
    : arrivalAirports;
return (
    <div>
      <div className="formmain">

        <form className="form-design" onSubmit={handleFlightSubmit}>
          <div className="flight_design">

            {/* Trip Type Radio Buttons */}
            <div className="mb-4 radio_design">
              {['oneway', 'round trip', 'multicity'].map((type) => (
                <label 
key={type} className="mr-4">
                  <input
                    type="radio"
                    name="journey_type"
                    value={type}
                    checked={tripType 
=== type}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTripType(value);

                      if (value === 'multicity') {
    
                    setMultiCitySegments([
                          {
                            from: '',
                         
   to: '',
                            departureDate: null,
                            returnDate: null,
                            adults: 1,
         
                   children: 0,
                            infants: 0,
                            cabin_class: '1',
                      
      showDropdown: false
                          }
                        ]);
}
                    }}
                  />{' '}
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </label>
              ))}
           
 </div>

            {/* MultiCity Mode */}
            {tripType === 'multicity' ?
(
              <>
                {multiCitySegments.map((segment, index) => (
                  <div key={index} className="flex multicity-row" style={{ marginBottom: '25px', position: 'relative' }}>

                    {/* From */}
                  
  <div className="select_input">
                      <label>From</label>
                      <Select
                        className="input-design"
                        options={airportOptions}
     
                   value={airportOptions.find(opt => opt.value === segment.from)}
                        onChange={(selected) => {
                          const updated = [...multiCitySegments];
                      
    updated[index].from = selected?.value || '';
                          setMultiCitySegments(updated);
                        }}
                        placeholder="From"
                  
      formatOptionLabel={formatAirportOption}
                      />
                    </div>

                    {/* To */}
                    <div className="select_input">
         
             <label>To</label>
                      <Select
                        className="input-design"
                        options={airportOptions}
                 
       value={airportOptions.find(opt => opt.value === segment.to)}
                        onChange={(selected) => {
                          const updated = [...multiCitySegments];
updated[index].to = selected?.value || '';
                          setMultiCitySegments(updated);
                        }}
                        placeholder="To"
                        formatOptionLabel={formatAirportOption}
                      />
                    </div>

    
                {/* Departure */}
                    <div className="select_input">
                      <label>Departure</label>
                      <DatePicker
                 
       selected={segment.departureDate}
                        onChange={(date) => {
                          const updated = [...multiCitySegments];
updated[index].departureDate = date;
                          setMultiCitySegments(updated);
                        }}
                        dateFormat="dd MMM, yy"
                        customInput={<CustomDateInput />}
                      />
                    </div>

   
                 {/* Travellers & Class */}
                    {index === 0 && (

                      <div className="select_input" ref={dropdownRef}>
                        <label>Travellers & Class</label>
     
                   <div
                          className="input-design_input"
                          onClick={() => toggleDropdown(0)}
                          style={{ 
cursor: 'pointer' }}
                        >
                          {multiCitySegments[0].adults} Adult{multiCitySegments[0].adults > 1 ? 's' : ''},
                          {multiCitySegments[0].children} Child{multiCitySegments[0].children > 1 ? 'ren' : ''},
        
                  {multiCitySegments[0].infants} Infant{multiCitySegments[0].infants > 1 ? 's' : ''},
                          {travelClassLabel[multiCitySegments[0].cabin_class]}
                        </div>

                        {multiCitySegments[0].showDropdown 
&& (
                          <div style={{
                            position: 'absolute',
                            background: 'white',
              
              border: '1px solid #ccc',
                            borderRadius: '5px',
                            padding: '10px',
                         
   zIndex: 10
                          }}>
                            {/* Adults */}
                            <div style={{ marginBottom: '10px' }}>
        
                      <label>Adults</label>
                              <input
                                type="number"
                
                min="1"
                                value={multiCitySegments[0].adults}
                                onChange={(e) => {
                  
                const updated = [...multiCitySegments];
updated[0].adults = parseInt(e.target.value);
                                  setMultiCitySegments(updated);
                                }}
                                className="input-design_input"
                              />
                            </div>
      
                      {/* Children */}
                            <div style={{ marginBottom: '10px' }}>
                              <label>Children</label>
              
                <input
                                type="number"
                                min="0"
                    
            value={multiCitySegments[0].children}
                                onChange={(e) => {
                                  const updated = [...multiCitySegments];
updated[0].children = parseInt(e.target.value);
                                  setMultiCitySegments(updated);
                                }}
                                className="input-design_input"
                              />
                            </div>
      
                      {/* Infants */}
                            <div style={{ marginBottom: '10px' }}>
                              <label>Infants</label>
              
                <input
                                type="number"
                                min="0"
                    
            value={multiCitySegments[0].infants}
                                onChange={(e) => {
                                  const updated = [...multiCitySegments];
updated[0].infants = parseInt(e.target.value);
                                  setMultiCitySegments(updated);
                                }}
                                className="input-design_input"
                              />
                            </div>
      
                      {/* Class */}
                            <div>
                              <label>Class</label>
                  
            <select
                                value={multiCitySegments[0].cabin_class}
                                onChange={(e) => {
                      
            const updated = [...multiCitySegments];
                                  updated[0].cabin_class = e.target.value;
                                  setMultiCitySegments(updated);
}}
                                className="input-design_input"
                              >
                                <option value="2">Economy</option>
     
                           <option value="3">Premium Economy</option>
                                <option value="4">Business</option>
                                <option value="5">Premium Business</option>
    
                            <option value="6">First</option>
                              </select>
                            </div>
             
             </div>
                        )}
                      </div>
                    )}

                    {index 
> 0 && (
                      <button
                        type="button"
                        onClick={() => handleRemoveSegment(index)}
                        style={{ 
position: 'absolute', right: -25, top: 5 }}
                      >
                        ❌
                      </button>
                    )}
      
            </div>
                ))}

                <div style={{ marginBottom: '20px' }}>
                  <button type="button" onClick={handleAddSegment} className="add-segment-btn">
                    + Add City
         
         </button>
                </div>
              </>
            ) : (
              // Oneway / Roundtrip Mode
              <div className="flex">

              
  {/* From */}
                <div className="select_input">
                  <label>From</label>
                  <Select
                    name="origin"
                    className="input-design"
   
                 options={airportOptions}
                    value={airportOptions.find(opt => opt.value === form.origin)}
                    onChange={(selected) => setForm(prev => ({ ...prev, origin: selected?.value ||
'' }))}
                    placeholder="From"
                    formatOptionLabel={formatAirportOption}
                  />
                </div>

                {/* To */}
       
         <div className="select_input">
                  <label>To</label>
                  <Select
                    name="destination"
                    className="input-design"
              
      options={airportOptions}
                    value={airportOptions.find(opt => opt.value === form.destination)}
                    onChange={(selected) => setForm(prev => ({ ...prev, destination: selected?.value || '' }))}
                    placeholder="To"
                    
formatOptionLabel={formatAirportOption}
                  />
                </div>

                {/* Departure */}
                <div className="select_input">
                  <label>Departure</label>
             
     <DatePicker
                    selected={form.departure_date}
                    onChange={(date) => setForm(prev => ({ ...prev, departure_date: date }))}
                    dateFormat="dd MMM, yy"
                    customInput={<CustomDateInput />}
    
              />
                </div>

                {/* Return */}
                <div className="select_input">
                  <label>Return</label>
                 
 <DatePicker
                    selected={form.arrival_date}
                    onChange={(date) => setForm(prev => ({ ...prev, arrival_date: date }))}
                    dateFormat="dd MMM, yy"
                    customInput={<CustomDateInputreturn disabled={tripType !== 'round trip'} />}
    
                disabled={tripType !== 'round trip'}
                  />
                </div>

                {/* Travellers & Class */}
                <div className="select_input" ref={dropdownRef}>
         
         <label>Travellers & Class</label>
                  <div
                    className="input-design_input"
                    onClick={() => setShowTravelDropdown(!showTravelDropdown)}
                    style={{ cursor: 'pointer' }}
      
            >
                    {form.adults} Adult{form.adults > 1 ?
's' : ''}, {form.children} Children{form.children > 1 ? 's' : ''},{form.infants} Infants{form.infants > 1 ?
's' : ''}, {travelClassLabel[form.cabin_class]}
                  </div>

                  {showTravelDropdown && (
                    <div style={{
                      position: 'absolute',
               
       background: 'white',
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                      padding: '10px',
                     
 zIndex: 10
                    }}>
                      <div style={{ marginBottom: '10px' }}>
                        <label>Adults</label>
                        <input
    
                      type="number"
                          min="1"
                          value={form.adults}
                          
onChange={(e) => setForm(prev => ({ ...prev, adults: parseInt(e.target.value) }))}
                          className="input-design_input"
                        />
                      </div>
                    
  <div style={{ marginBottom: '10px' }}>
                        <label>Children</label>
                        <input
                          type="number"
                    
      min="0"
                          value={form.children}
                          onChange={(e) => setForm(prev => ({ ...prev, children: parseInt(e.target.value) }))}
                          className="input-design_input"
        
                />
                      </div>
                      <div style={{ marginBottom: '10px' }}>
                        <label>Infants</label>
            
            <input
                          type="number"
                          min="0"
                          value={form.infants}
          
                onChange={(e) => setForm(prev => ({ ...prev, infants: parseInt(e.target.value) }))}
                          className="input-design_input"
                        />
                      </div>
    
                  <div>
                        <label>Class</label>
                        <select
                          value={form.cabin_class}
        
                  onChange={(e) => setForm(prev => ({ ...prev, cabin_class: e.target.value }))}
                          className="input-design_input"
                        >

                        
  <option value="2">Economy</option>
                          <option value="3">Premium Economy</option>
                          <option value="4">Business</option>
                          <option value="5">Premium Business</option>
              
            <option value="6">First</option>
                        </select>
                      </div>
                    </div>
                  )}
   
             </div>
              </div>
            )}
          </div>

          {/* Submit */}
          <button type="submit" className="submit-btn-design" disabled={loading}>
            {loading ?
'Searching...' : 'Search Flights'}
          </button>
        </form>

      </div>


      <div className='flight_design_page'>
  <div className="filter_sidebar">
          <h3 className="fil_title">Filters</h3>

          {(() => {
            const isInternational = flightResults.some(flight => {
              const allLegs = flight.Segments?.flat() || [];
    
          return allLegs.some(
                seg =>
                  seg.Destination?.Airport?.CountryName &&
                  seg.Destination.Airport.CountryName !== "India"
              );
            });

       
     return (
              <>
                {tripType === "round trip" && (
                  <div className="filter_tabs">
                    <button className={filterTab === "onward" ? "active" : ""} onClick={() => setFilterTab("onward")}>Onward Filters</button>
         
           <button className={filterTab === "return" ? "active" : ""} onClick={() => setFilterTab("return")}>Return Filters</button>
                  </div>
                )}

                {tripType === "round trip" && !isInternational && (
                  <p style={{ marginBottom: 
"10px", fontWeight: "bold", color: "#333", marginLeft: "25px" }}>
                    {filterTab === "onward" ?
"Onward Filters" : "Return Filters"}
                  </p>
                )}

                <div className="filter_design">
                  <p>Stops</p>
                  {["Non Stop", "1 Stop", "2 Stop"].map((stop, i) => (
 
                   <div key={i}>
                      <label>
                        <input
                          type="checkbox"
        
                  checked={(filterTab === "onward" ? onwardFilters.stops : returnFilters.stops).includes(stop)}
                          onChange={() => handleFilterChange("stops", stop, filterTab)}
                        />
                      
  {stop}
                      </label>
                    </div>
                  ))}
                </div>

                <div className="filter_design">
     
             <p>Airlines</p>
                  {displayedAirlines.map((airline, i) => (
                    <div key={i}>
                      <label>
                       
 <input
                          type="checkbox"
                          value={airline}
                          checked={(filterTab === "onward" ?
onwardFilters.airlines : returnFilters.airlines).includes(airline)}
                          onChange={() => handleFilterChange("airlines", airline, filterTab)}
                        />
                        {airline}
                    
  </label>
                    </div>
                  ))}
                  {uniqueAirlines.length > 4 && (
                    <button className="filter_more" type="button" onClick={() => setShowAllAirlines(!showAllAirlines)} style={{ marginTop: "8px" }}>
         
             {showAllAirlines ? "Show Less" : "Show More"}
                    </button>
                  )}
                </div>

                <div className="filter_design">
          
        <p>Price Range</p>
                  <div className="range_style">
                    <div className="slider-container">
                      <div className="slider-track"></div>

                      <div
      
                  className="slider-range"
                        style={{
                          left: `${((filterTab === "onward" ?
onwardFilters.priceRange[0] : returnFilters.priceRange[0]) / maxPrice) * 100}%`,
                          right: `${100 - ((filterTab === "onward" ? onwardFilters.priceRange[1] : returnFilters.priceRange[1]) / maxPrice) * 100}%`,
                        }}
                      ></div>

         
             <input
                        type="range"
                        min={minPrice}
                        max={maxPrice}
               
         value={filterTab === "onward" ?
onwardFilters.priceRange[0] : returnFilters.priceRange[0]}
                        onChange={(e) => {
                          const newMin = Math.min(+e.target.value, (filterTab === "onward" ? onwardFilters.priceRange[1] : returnFilters.priceRange[1]) - 1000);
if (filterTab === "onward") setOnwardFilters(prev => ({ ...prev, priceRange: [newMin, prev.priceRange[1]] }));
else setReturnFilters(prev => ({ ...prev, priceRange: [newMin, prev.priceRange[1]] }));
                        }}
                        className="thumb thumb-left"
                      />

                      <input
                      
  type="range"
                        min={minPrice}
                        max={maxPrice}
                        value={filterTab === "onward" ?
onwardFilters.priceRange[1] : returnFilters.priceRange[1]}
                        onChange={(e) => {
                          const newMax = Math.max(+e.target.value, (filterTab === "onward" ? onwardFilters.priceRange[0] : returnFilters.priceRange[0]) + 1000);
if (filterTab === "onward") setOnwardFilters(prev => ({ ...prev, priceRange: [prev.priceRange[0], newMax] }));
else setReturnFilters(prev => ({ ...prev, priceRange: [prev.priceRange[0], newMax] }));
                        }}
                        className="thumb thumb-right"
                      />
                    </div>

                    <label>
    
                  ₹{(filterTab === "onward" ? onwardFilters.priceRange[0] : returnFilters.priceRange[0]).toLocaleString()} - ₹{(filterTab === "onward" ? onwardFilters.priceRange[1] : returnFilters.priceRange[1]).toLocaleString()}
                    </label>
                  </div>
                </div>

              
  {tripType !== "multicity" && (
                  <>
                    <div className="filter_design">
                      <p>Departure Time</p>
                      {["Before 6AM", "6AM to 12PM", "12PM to 6PM", "After 6PM"].map((slot, 
i) => (
                        <div key={i}>
                          <label>
                            <input
                   
           type="checkbox"
                              checked={(filterTab === "onward" ? onwardFilters.departureTimes : returnFilters.departureTimes).includes(slot)}
                              onChange={() => handleFilterChange("departureTimes", slot, filterTab)}
                   
         />
                            {slot}
                          </label>
                        </div>
             
         ))}
                    </div>

                    <div className="filter_design">
                      <p>Arrival Time</p>
                      {["Before 6AM", "6AM to 12PM", 
"12PM to 6PM", "After 6PM"].map((slot, i) => (
                        <div key={i}>
                          <label>
                            <input
              
                type="checkbox"
                              checked={(filterTab === "onward" ?
onwardFilters.arrivalTimes : returnFilters.arrivalTimes).includes(slot)}
                              onChange={() => handleFilterChange("arrivalTimes", slot, filterTab)}
                            />
                            {slot}
        
                  </label>
                        </div>
                      ))}
                    </div>
                
  </>
                )}

                {tripType !== 'multicity' && (
                  <div className='filter_design'>
                    <p>Departure Airports</p>
                    {(filterTab === 
'onward' ? departureAirports : arrivalAirports).slice(0, 3).map((airport, i) => (
                      <div key={airport.code || i}>
                        <label>
                          <input
                 
           type="checkbox"
                            value={airport.code}
                            checked={(filterTab === 'onward' ? onwardFilters.departureAirports : returnFilters.departureAirports).includes(airport.code)}
                           
 onChange={() => handleFilterChange('departureAirports', airport.code, filterTab)}
                          />
                          {airport.name} {airport.city ?
`(${airport.city})` : ''} {airport.code ? ` - ${airport.code}` : ''}
                        </label>
                      </div>
                    ))}
                  </div>
       
         )}

                {tripType !== 'multicity' && (
                  <div className='filter_design'>
                    <p>Arrival Airports</p>
                    {(filterTab === 'onward' ? visibleArrivalAirports : departureAirports).slice(0, 3).map((airport, i) => (
 
                     <div key={airport.code || i}>
                        <label>
                          <input
                          
  type="checkbox"
                            value={airport.code}
                            checked={(filterTab === 'onward' ? onwardFilters.arrivalAirports : returnFilters.arrivalAirports).includes(airport.code)}
                            onChange={() => handleFilterChange('arrivalAirports', airport.code, filterTab)}
    
                      />
                          {airport.name} {airport.city ? `(${airport.city})` : ''} {airport.code ?
` - ${airport.code}` : ''}
                        </label>
                      </div>
                    ))}
                  </div>
            
    )}
              </>
            );
})()}
        </div>







<div className="flights_data">
  {/* 🔹 Sorting Bar */}
  <div className="sorting-bar">
    <span><b>Sort By:</b></span>
    {["departure", "duration", "arrival", "price"].map((field) => {
      const activeSortBy =
        tripType === "round trip"
          ? filterTab === "onward"
            ? onwardSortBy
            : returnSortBy
          : sortBy;

      const activeSortOrder =
        tripType === "round trip"
          ? filterTab === "onward"
            ? onwardSortOrder
            : returnSortOrder
          : sortOrder;

      return (
        <button
          key={field}
          className={`sort-btn ${activeSortBy === field ? "active" : ""}`}
          onClick={() => handleSort(field)}
        >
          {field.charAt(0).toUpperCase() + field.slice(1)}{" "}
          {activeSortBy === field && (activeSortOrder === "asc" ? "↓" : "↑")}
        </button>
      );
    })}
  </div>

  {/* 🔹 Flight Results */}
  {loading ? (
    <p>Loading...</p>
  ) : tripType === "oneway" ? (
    (() => {
      const filteredFlights = applyFilters(
        getUniqueFlights(flightResults),
        onwardFilters
      );
      const sortedFlights = sortFlights(filteredFlights, sortBy, sortOrder);

      return sortedFlights.length > 0 ? (
        sortedFlights.map((f, i) => (
          <div key={i}>
            {f.Segments?.flat()?.map((seg, j) => (
              <FlightDetailsCard
                key={`${i}-${j}`}
                flight={f}
                seg={seg}
                filters={onwardFilters}
              />
            ))}
          </div>
        ))
      ) : (
        <p>No flights found.</p>
      );
    })()
  ) : tripType === "round trip" ? (
    (() => {
      const isInternational = flightResults.some((flight) => {
        const allLegs = flight.Segments?.flat() || [];
        return allLegs.some(
          (seg) =>
            seg.Destination?.Airport?.CountryName &&
            seg.Destination.Airport.CountryName !== "India"
        );
      });

      const filteredOnward = sortFlights(
        applyFilters(getUniqueFlights(flightResults), onwardFilters, "onward"),
        onwardSortBy,
        onwardSortOrder,
        "onward"
      );

      const filteredReturn = sortFlights(
        applyFilters(getUniqueFlights(returnResults), returnFilters, "return"),
        returnSortBy,
        returnSortOrder,
        "return"
      );

      if (isInternational) {
        return (
          <InternationalReturnCard
            onwardResults={filteredOnward}
            returnResults={filteredReturn}
            activeTab={filterTab}
            onTabChange={setFilterTab}
          />
        );
      }

      return (
        <div className="round_trip_flights" style={{ display: "flex", gap: 8 }}>
          {/* Onward Flights */}
          <div className="onward_column" style={{ flex: 1 }}>
            {filteredOnward.length > 0 ? (
              filteredOnward.map((f, i) => (
                <div key={`onward-${i}`}>
                  {f.Segments?.flat()?.map((seg, j) => (
                    <FlightDetailsCard
                      key={`onward-${i}-${j}`}
                      flight={f}
                      seg={seg}
                      tripType="round trip"
                      legType="onward"
                      onSelectFlight={setSelectedOnward}
                      filters={onwardFilters}
                    />
                  ))}
                </div>
              ))
            ) : (
              <p>No onward flights found.</p>
            )}
          </div>

          {/* Return Flights */}
          <div className="return_column" style={{ flex: 1 }}>
            {filteredReturn.length > 0 ? (
              filteredReturn.map((f, i) => (
                <div key={`return-${i}`}>
                  {f.Segments?.flat()?.map((seg, j) => (
                    <FlightDetailsCard
                      key={`return-${i}-${j}`}
                      flight={f}
                      seg={seg}
                      tripType="round trip"
                      legType="return"
                      onSelectFlight={setSelectedReturn}
                      filters={returnFilters}
                    />
                  ))}
                </div>
              ))
            ) : (
              <p>No return flights found.</p>
            )}
          </div>

          {/* Sticky Bar */}
          {(selectedOnward || selectedReturn) && (
            <div className="sticky-bar">
              {/* Onward Info */}
              <div className="sticky-column">
                {selectedOnward ? (
                  <>
                    <div className="flight-info">
                      {selectedOnward.Segments?.[0]?.[0]?.Airline?.AirlineCode && (
                        <img
                          src={`/airlinesimages/${selectedOnward.Segments[0][0].Airline.AirlineCode}.gif`}
                          alt={selectedOnward.Segments[0][0].Airline.AirlineName}
                          style={{ width: "30px", height: "30px" }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/airlinesimages/default.gif";
                          }}
                        />
                      )}
                      <span>
                        {selectedOnward.Segments[0][0].Airline.AirlineName} (
                        {selectedOnward.Segments[0][0].Airline.AirlineCode}-
                        {selectedOnward.Segments[0][0].Airline.FlightNumber})
                        <br />
                        {selectedOnward.Segments[0][0].Origin.Airport.CityName} →{" "}
                        {selectedOnward.Segments[0].slice(-1)[0].Destination.Airport.CityName}
                      </span>
                    </div>
                    <p className="timing">
                      Departure:{" "}
                      {new Date(selectedOnward.Segments[0][0].Origin.DepTime).toLocaleString([], {
                        weekday: "short",
                        day: "2-digit",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                      <br />
                      Arrival:{" "}
                      {new Date(
                        selectedOnward.Segments[0].slice(-1)[0].Destination.ArrTime
                      ).toLocaleString([], {
                        weekday: "short",
                        day: "2-digit",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                      <br />
                      <strong>
                        ₹{Math.round(selectedOnward.Fare?.PublishedFare).toLocaleString("en-IN")}
                      </strong>
                    </p>
                  </>
                ) : (
                  <p style={{ color: "#888" }}>No onward selected</p>
                )}
              </div>

              {/* Return Info */}
              <div className="sticky-column">
                {selectedReturn ? (
                  <>
                    <div className="flight-info">
                      {selectedReturn.Segments?.[0]?.[0]?.Airline?.AirlineCode && (
                        <img
                          src={`/airlinesimages/${selectedReturn.Segments[0][0].Airline.AirlineCode}.gif`}
                          alt={selectedReturn.Segments[0][0].Airline.AirlineName}
                          style={{ width: "30px", height: "30px" }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/airlinesimages/default.gif";
                          }}
                        />
                      )}
                      <span>
                        {selectedReturn.Segments[0][0].Airline.AirlineName} (
                        {selectedReturn.Segments[0][0].Airline.AirlineCode}-
                        {selectedReturn.Segments[0][0].Airline.FlightNumber})
                        <br />
                        {selectedReturn.Segments[0][0].Origin.Airport.CityName} →{" "}
                        {selectedReturn.Segments[0].slice(-1)[0].Destination.Airport.CityName}
                      </span>
                    </div>
                    <p className="timing">
                      Departure:{" "}
                      {new Date(selectedReturn.Segments[0][0].Origin.DepTime).toLocaleString([], {
                        weekday: "short",
                        day: "2-digit",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                      <br />
                      Arrival:{" "}
                      {new Date(
                        selectedReturn.Segments[0].slice(-1)[0].Destination.ArrTime
                      ).toLocaleString([], {
                        weekday: "short",
                        day: "2-digit",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                      <br />
                      <strong>
                        ₹{Math.round(selectedReturn.Fare?.PublishedFare).toLocaleString("en-IN")}
                      </strong>
                    </p>
                  </>
                ) : (
                  <p style={{ color: "#888" }}>No return selected</p>
                )}
              </div>

              {/* Total Fare + Book Now */}
              <div
                className="sticky-column"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  gap: "10px",
                }}
              >
                <p className="sticky-fare" style={{ fontWeight: "bold" }}>
                  ₹
                  {Math.round(
                    (selectedOnward?.Fare?.PublishedFare || 0) +
                      (selectedReturn?.Fare?.PublishedFare || 0)
                  ).toLocaleString("en-IN")}
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    navigate("/book-flight", {
                      state: { selectedOnward, selectedReturn, tripType },
                    })
                  }
                >
                  Book Now
                </button>
              </div>
            </div>
          )}
        </div>
      );
    })()
  ) : tripType === "multicity" ? (
    (() => {
      const filteredFlights = applyFilters(
        getUniqueFlights(flightResults),
        onwardFilters,
        "multicity"
      );
      const sortedFlights = sortFlights(filteredFlights, sortBy, sortOrder, "multicity");

      return sortedFlights.length > 0 ? (
        <div className="multicity_segment">
          {sortedFlights.map((f, i) => (
            <MultiCityFlights key={`multi-${i}`} flight={f} filters={onwardFilters} />
          ))}
        </div>
      ) : (
        <p>No multicity flights found.</p>
      );
    })()
  ) : (
    <p>No flights found.</p>
  )}
</div>






      </div>

    </div>

  );
};

export default Flights;